import faq from '@/helpers/faq';
import categories from '@/helpers/categories';
import checkout from '@/helpers/Checkout';

export default {
    init() {
        categories.init();
        faq.init();
        checkout.init();
    },
};
